import React, { useState } from "react";
import Modal from "../modal/Modal";
import styles from "./UploadModal.module.scss";
import Button from "component/atom/forms/button/Button";

const UploadModal = ({
  title,
  isOpen,
  onClose,
  bodyHeaders,
  footer,
  setSelectedFiles,
  handleSubmit,
}) => {
  const [files, setFiles] = useState([]);
  const [dragging, setDragging] = useState(false);

  const handleFileSelect = (event) => {
    const newFiles = Array.from(event.target.files).filter(
      (file) => !files.some((f) => f.name === file.name)
    );
    const updatedFiles = [...files, ...newFiles];
    setFiles(updatedFiles);
    setSelectedFiles(updatedFiles);
  };

  const handleRemoveFile = (fileName) => {
    const updatedFiles = files.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setSelectedFiles(updatedFiles);
  };

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  const formatFileSize = (size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const droppedFiles = Array.from(event.dataTransfer.files).filter(
      (file) => !files.some((f) => f.name === file.name)
    );
    const updatedFiles = [...files, ...droppedFiles];
    setFiles(updatedFiles);
    setSelectedFiles(updatedFiles);
  };

  return (
    <Modal title={title} isOpen={isOpen} onClose={onClose}>
      <div className={styles["modal-body"]}>
        <div>{bodyHeaders}</div>
        <div
          className={styles["drag-drop-container"]}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <div
            className={styles["upload-image-container"]}
            onClick={handleButtonClick}
          >
            <img src="/images/upload-file.svg" alt="Upload Icon" />
            <span>Drag and Drop or Upload</span>
          </div>
          <Button buttonType="button" label="Upload" onClick={handleSubmit} />
          <input
            id="fileInput"
            type="file"
            multiple
            style={{ display: "none" }}
            onChange={handleFileSelect}
          />
        </div>

        <div>{footer}</div>
        <div>
          {files.length > 0 && (
            <div className={styles["file-list"]}>
              {files.map((file, index) => (
                <React.Fragment key={index}>
                  <div className={styles["file-item"]}>
                    <div className={styles["file-name-container"]}>
                      <img src="/images/file-icon.svg" alt="File Icon" />
                      <span className={styles["file-name"]}>{file.name}</span>
                      <span className={styles["file-size"]}>
                        ({formatFileSize(file.size)})
                      </span>
                    </div>
                    <img
                      className={styles["close-icon"]}
                      src="/images/close-grey.svg"
                      alt="Remove"
                      onClick={() => handleRemoveFile(file.name)}
                    />
                  </div>
                  {index < files.length - 1 && (
                    <div className={styles["separator"]}></div>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default UploadModal;
